import { render, staticRenderFns } from "./WppGroupModal.vue?vue&type=template&id=6fc96fce&scoped=true"
import script from "./WppGroupModal.vue?vue&type=script&lang=js"
export * from "./WppGroupModal.vue?vue&type=script&lang=js"
import style0 from "./WppGroupModal.vue?vue&type=style&index=0&id=6fc96fce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fc96fce",
  null
  
)

export default component.exports